export default __webpack_public_path__ + "atomic/_patterns/01-atoms/country-map-svg/_country-map-svg.twig";